import { GraphForm } from "./graph_form";
import { Keyword } from "./keyword";
import { TargetDate } from "./target_date";
import { ConditionPanel } from "./condition_panel";
import { StatsGraph } from "./stats_graph";
import $ from "jquery";
import { ItemAspect } from "./item_aspect";

class MatchesForm extends GraphForm {
  private graph: StatsGraph;
  private keyword: Keyword;
  private itemAspect: any;
  private conditionPanel: ConditionPanel;
  private targetDate: TargetDate;

  constructor() {
    super();

    this.graph = new StatsGraph(this.canvasElement(), {
      xAxis: StatsGraph.AxisPolicy.forPartition(this.partition()),
      yAxis: StatsGraph.FloatAxis,
      legend: StatsGraph.RightColumnLegend,
    });

    this.keyword = new Keyword($("#keyword"));
    this.itemAspect = new ItemAspect();
    this.conditionPanel = new ConditionPanel(this.formElement());
    this.targetDate = this.conditionPanel.targetDate;
  }

  protected canvasElement(): JQuery {
    return $("#ksi_graph");
  }

  protected formElement(): JQuery {
    return $("#matches_form");
  }

  private partition(): string {
    return $("#partition").val() as string;
  }

  initialize(invalidParameterCombinations?: any): void {
    this.keyword.initialize();
    this.conditionPanel.initialize(invalidParameterCombinations);
  }

  updateCsvUrl(url: string): void {
    const elem = $(".ksi_graph_box .csv_button");
    elem.removeClass("disabled enable_later");
    let a = elem.find("a");

    if (a.length > 0) {
      a.attr("href", url);
    } else {
      // first time
      const img = elem.html();
      elem.html("<a></a>");
      a = elem.children();
      a.append(img);
      a.attr("href", url);
    }
  }

  onAspectChange(f: () => void): void {
    this.itemAspect.onAspectChange(f);
  }

  onSeriesRemoval(f: (series: any) => void): void {
    this.graph.onSeriesRemoval(f);
  }

  render(): void {
    this.graph.drawAll();
  }

  keywordValue(): string {
    return this.keyword.value();
  }

  showKeywordNotFoundError(keyword: string): void {
    this.graph.drawMessage(`
      「${keyword}」は見付かりませんでした。
      別の単語をお試しください。
    `);
  }

  showNoDataMessage(): void {
    this.graph.drawMessage(`
      この条件では組み合わせのデータが存在しません。
      単語や期間、集計単位などを変更してお試しください。
    `);
  }

  showHttpErrorMessage(res: { status: number }): void {
    this.graph.drawErrorMessage(`
      申し訳ありません、通信エラーが発生しました。
      少し時間をおいて再度お試しください。
      ステータス: ${res.status}, ${new Date()}
    `);
  }
}

export { MatchesForm };
